import { each } from '../shared/utils/dom';

/**
 * function is responsible for creating bar graphs in the Portal
 */
export default function Chart() {
  /**
   * Find all instances of .js-chart
   */
  const charts = document.querySelectorAll('.js-chart__chart_budget');

  if (charts) {
    /**
     * Loop over all charts and update their bar graphs accordingly
     */
    each(charts, (chart) => {
      const points = [];
      const lineValues = [];
      const bars = chart.querySelectorAll('.js-chart__budgetbox');
      const horizontalLines = chart.querySelectorAll('.js-chart__horizontal-line');

      each(bars, (el) => {
        const billedAmt = parseInt(el.dataset.heightBilled, 10);
        points.push(billedAmt);
        const budgetAmt = parseInt(el.dataset.heightBudget, 10);
        points.push(budgetAmt);
      });

      /**
       * equivalent to Math.max(1, 2, 3), but you can use
       * on programmatically constructed arrays of any size.
       */
      const max = Math.max.apply(null, points);
      const quarters = Math.ceil((max / 4) / 5) * 5;

      for (let i = 0; i < 5; i += 1) {
        lineValues.push(i * quarters);
      }

      const upper = quarters * 4;
      each(bars, (el) => {
        setTimeout(() => {
          const bar = el;
          // get the height data
          const billedBar = bar.querySelector('.js-chart__budgetbar--utility');
          const budgetBar = bar.querySelector('.js-chart__budgetbar--budget');
          const barInfo = bar.querySelector('.js-chart__info');
          const billedBarHeight = (parseInt(el.dataset.heightBilled, 10) / upper) * 100;
          const budgetBarHeight = (parseInt(el.dataset.heightBudget, 10) / upper) * 100;
          // set the height data
          billedBar.style.height = billedBarHeight + '%'; // eslint-disable-line prefer-template
          budgetBar.style.height = budgetBarHeight + '%'; // eslint-disable-line prefer-template
          barInfo.style.bottom = (billedBarHeight + 5) + '%'; // eslint-disable-line prefer-template
        }, 300);
      });

      for (let i = 0; horizontalLines.length > i; i += 1) {
        horizontalLines[i].dataset.lineValue = lineValues[i];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/budgetcharts.js